module.exports = __webpack_public_path__ + "img/logo.3908d4a6.png";